<template>
  <footer>
    <div class="footer">
      <div>© 2018 WhiteOnWhite - All Rights Reserved.</div>
      <div>About WhiteOnWhite </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
};
</script>